
const ModalExitAlertStyle = theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: "center"
    },
    modalWrapper: {
        outline: "none",
        maxHeight: 200,
        width: "100%",
        position: "absolute",
        transition: "all .5s ease",
        display: "flex",
        boxShadow: "0 -5px 10px 0 rgba(0,0,0,0.5)",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
    },
    modalNoConnectionWrapper: {
        outline: "none",
        maxHeight: 200,
        width: "100%",
        position: "absolute",
        transition: "all .5s ease",
        display: "flex",
        boxShadow: "0 -5px 10px 0 rgba(0,0,0,0.5)",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
    },
    modalHeader: {
        maxHeight: 24,
        display: "flex",
        flex: 1,
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 16,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        marginLeft: 24,
        marginTop: 7,
        alignItems: "center"
    },
    modalAlertHeader: {
        color: "#E12929 !important"
    },
    modalBody: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
    },
    modalActionWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: 8,
    },
    contentWrapper: {
        display: "flex",
        flex: 1,
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px",
        whiteSpace: "pre-wrap",
        padding: "8px 24px"
    },
    buttonStyle: {
        boxShadow: 'none',
        width: 150,
        height: 30,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: 0,
        marginRight: 20,
        fontWeight: "bold",
        backgroundColor: '#00ad50',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:disabled': {
            color: 'white',
            boxShadow: 'none',
        },
    },
    cancelButtonStyle: {
        boxShadow: 'none',
        width: 150,
        height: 30,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: 0,
        border: "1px solid #4d4d4d",
        color: "#242424",
        fontWeight: "bold",
        backgroundColor: 'white',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
    },
})

export default ModalExitAlertStyle;